// extracted by mini-css-extract-plugin
module.exports = {"bio":"Bios-module__bio___1gRKv","title":"Bios-module__title___D4_04","collapsed":"Bios-module__collapsed___1Ka-W","new":"Bios-module__new___3DPsU"};